import React from "react";
import Preloader from "./src/components/preloader";

export const wrapPageElement = ({ element, props }) => {
  return <Preloader {...props}>{element}</Preloader>;
};
